import RouterRedirect from 'viralstyle-ui/src/VsRouterRedirect';

import Collection from './Collection';

export default {
  path: '/store/:publicName/:collectionSlug',
  component: RouterRedirect,
  redirect: to => {
    return `/store/${to.params.publicName}/${to.params.collectionSlug}/1`;
  },
  name: 'collectionRoot',
  children: [{
    path: '/store/:publicName/:collectionSlug/:page',
    name: 'collection',
    component: Collection,
    props: true,
  }, ],
};

export const wlRoutes = {
  path: '/collection/:collectionSlug',
  component: RouterRedirect,
  redirect: to => {
    return `/collection/${to.params.collectionSlug}/1`;
  },
  name: 'collectionRoot',
  children: [{
    path: '/collection/:collectionSlug/:page',
    name: 'collection',
    component: Collection,
    props: true,
  }, ],
};